// @ utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { get } = require('services/api');
const { getNumOfDaysBetweenDates } = require('utilities/dateHelper/dateHelper');
// @ constants
const actionTypes = require('constants/RAConstants/actionTypes');
const { CONTRIBUTION_PERIOD_MONTHLY } = require('constants/RAConstants');
const { GBI } = require('constants/userProfile');

const changeYears = years => ({
    type: actionTypes.RA_EXPECTED_PROFITABILITY_CHANGE_YEARS,
    payload: { years },
});

const requestProjectionChartInProgress = () => ({
    type: actionTypes.RA_EXPECTED_PROFITABILITY_CHART_REQUEST,
});

const successProjectionChart = (data, dataPoints, product) => ({
    type: actionTypes.RA_EXPECTED_PROFITABILITY_CHART_SUCCESS,
    payload: { data, dataPoints, product },
});

const failureProjectionChart = data => ({
    type: actionTypes.RA_EXPECTED_PROFITABILITY_CHART_FAILURE,
    payload: { data },
});

const requestProjectionChart =
    (accessToken, { dataPoints = 6, product, balance = 0, freq = 1, mntPayment = 0, chartYears = null, cutDay = 0 }) =>
    (dispatch, getState) => {
        const { raExpectedProfitability, raManagementPlan, raCustomPlanByObjective, userProfile } = getState();
        const isGBI = userProfile.investmentType === GBI;
        let raState = raManagementPlan;

        if (isGBI) {
            raState = raCustomPlanByObjective;
        }

        const recurringContributionAmount = mntPayment || raState.get('recurringContributionAmount');
        const recurringContributionDay = raState.get('recurringContributionDay');
        const hasPeriodicity = recurringContributionAmount > 0;
        const periodicity = !hasPeriodicity ? 1 : freq !== 1 ? freq : raState.get('periodicity');
        let years;

        if (chartYears === 0) {
            const objectiveEndDate = getState().raCustomPlanByObjective.get('objectiveEndDate');
            const nDays = Math.abs(getNumOfDaysBetweenDates(objectiveEndDate));

            years = nDays / 365;
        } else {
            years = chartYears || raExpectedProfitability.get('chartYears');
        }

        const noOfChartPoints = raExpectedProfitability.get('noOfChartPoints');
        const dp = dataPoints === 2 ? dataPoints : noOfChartPoints;
        const investProfileValue = isGBI
            ? raCustomPlanByObjective.get('selectedStrategy')
            : raManagementPlan.get('investProfileValue');
        const params = {
            dataPoints: dp,
            years,
            mntPayment: recurringContributionAmount,
            freq: periodicity,
            balance: balance ? balance : raState.get('initialContributionAmount'),
            product: product != null ? product : investProfileValue,
        };

        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {
                cutDay:
                    periodicity === CONTRIBUTION_PERIOD_MONTHLY
                        ? cutDay === 0
                            ? recurringContributionDay
                            : cutDay
                        : 1,
            },
        };

        dispatch(requestProjectionChartInProgress());

        return get(apiURLBuilder.getURL('raProjectionChartSimulation', params), requestData)
            .then(response => {
                dispatch(successProjectionChart(response.body, dp, params.product));
            })
            .catch(error => {
                if (error.error) {
                    dispatch(failureProjectionChart(error.error.description));
                } else {
                    throw error;
                }
            });
    };

export default {
    changeYears,
    requestProjectionChart,
};
